export default __webpack_public_path__ + "static/media/ont-logo.19dd9dba.svg";